(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["laze-card-atc"] && !Shopify.designMode) return;
  try {
    class LazeCardAtc extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-laze-sizes]');
      this.map = json ? JSON.parse(json.textContent) : null;
      this.size = this.dataset.size;
      this.pills = [...this.querySelectorAll('[data-laze-size]')];
      this.input = this.querySelector('[ref="variantId"]');
      this.button = this.querySelector('[ref="addToCartButton"]');
      this.card = this.closest('product-card');

      this.pills.forEach((pill) =>
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          this.size = pill.dataset.lazeSize;
          this.pills.forEach((p) => {
            const on = p === pill;
            p.classList.toggle('is-selected', on);
            p.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          this.apply();
        })
      );

      // The swatch picker updates product-form's variant id (this product's variant); correct it for the size after.
      this.card?.addEventListener('variant:update', () => setTimeout(() => this.apply(), 0));
      this.querySelector('form')?.addEventListener('submit', () => this.apply(), true);
    }

    get colour() {
      const checked = this.card?.querySelector('swatches-variant-picker-component input[type="radio"]:checked');
      return checked ? checked.value : this.dataset.colour;
    }

    apply() {
      if (!this.map || !this.input) return;
      const entry = this.map[this.size]?.[this.colour];
      if (!entry) return;
      this.input.value = entry.id;
      if (this.button) {
        if (entry.available) this.button.removeAttribute('disabled');
        else this.button.setAttribute('disabled', 'true');
      }
    }
  }

  if (!customElements.get('laze-card-atc')) customElements.define('laze-card-atc', LazeCardAtc);
  } catch(e) { console.error(e); }
})();

})();
